import { render } from "./ProductoClusterCreate.vue?vue&type=template&id=6538cf43"
import script from "./ProductoClusterCreate.vue?vue&type=script&lang=js"
export * from "./ProductoClusterCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__